<style lang="scss" scoped="scoped">
	p {
		color: #303133;
	}

	.alert::-webkit-scrollbar {
		display: none;
	}
</style>


<template>
	<div ref="container"
		style="overflow: auto;height: 100%;position: relative;padding: 20px;display: flex;flex-direction: column;justify-content: space-between;">
		<div ref="titleBar" class="titleBar" style="flex-shrink: 0;">
			<p style="font-size: 16px;font-weight: 700;">
				{{$t('baojingxinxi')}}
				<!-- <span style="color: #909399;font-size: 12px;margin-left: 10px;">{{$t('xianshiyijieshu')}}</span> -->
			</p>
		</div>
		<div class="alert"
			style="flex: 1;display: flex;flex-direction: column;justify-content: flex-start;margin-top: 20px;overflow: auto;">

			<div v-for="(alert,index) in alerts"
				style="display: flex;justify-content: space-between;margin-bottom: 12px;">
				<div style="display: flex;align-items: center;">
					<div
						style="padding: 2px 8px;color: #419FFF;background-color: rgba(65, 159, 255, 0.1);border-radius: 4px;">
						{{$t(alert.name)}}
					</div>
					<div style="color: #606266;margin-left: 8px;">
						{{$t(alert.i18n)}}
					</div>
					<div style="color: #C0C4CC;margin-left: 8px;">
						{{ utils.toPretyDate(dayjs(alert.begin).format('YYYY-MM-DD HH:mm:ss'))}}
					</div>
				</div>
				<div style="font-size:10px;color: #F4F4F4;border-radius:12px ;padding: 2px 8px;display: flex;justify-content: center;align-items: center;"
					:style="{background: alert.flag==1?'#F56C6C':'#909399'}">
					{{alert.flag==1?$t('jinxingzhong'):$t('yijieshu')}}
				</div>
			</div>

		</div>



	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_home_about',
		components: {

		},

		data() {
			return {
				timmer: null,
				alerts: []
			};
		},
		
		created() {
			// this.timmer = setInterval(() => {
			// 	this.listAlarm()
			// }, 120000)
			this.listAlarm()
		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		watch: {
			'$attrs.orgId'(newValue, oldValue) {
				if (this.utils.isEqual(newValue, oldValue)) {
					return
				}
				this.listAlarm()
			},
			
		},
		activated() {
			this.resize()
		},
		destroyed() {
			clearInterval(this.timmer)
		},
		methods: {
			async listAlarm() {
				let response = await this.http.get('/web/equipment/home/listAlarm',{params:{orgId: this.$attrs.orgId}})
				this.alerts = response.data
			},

			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {
					this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight -
						20 - 20
				}, 800)
			},

		}
	};
</script>
